// src/components/ContentArea.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { MenuItem } from './SphereMenu'; // SphereMenuからMenuItemインターフェースをインポート
import { motion } from 'framer-motion'; // アニメーション用
import styled from '@emotion/styled'; // スタイル用

// ページをインポート
import Home from './Home';
import Philosophy from './Philosophy';
import Profile from './Profile';
import Works from './Works';
import Recruitment from './RecruitmentPage';
import ContactPage from './ContactPage'; // お問い合わせページ

const ContentContainer = styled.div`
  position: absolute;
  top: 10vh;
  right: 5vw;
  width: 45vw; /* 幅を調整して画面内に収める */
  max-width: 100vw; /* 画面幅を超えないようにする */
  height: 80vh;
  background-color: rgba(30, 30, 30, 0.95);
  backdrop-filter: blur(5px);
  border: 1px solid #444;
  border-radius: 12px;
  padding: 25px;
  color: #f0f0f0;
  z-index: 1;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);

  @media screen and (max-width: 768px) {
    top: 44vh; /* スマートフォン向けに中央に配置 */
    margin: 0 auto; /* 中央に配置 */
    height: 50vh; /* スマートフォン向けに高さを調整 */
    width: 90vw; /* スマートフォン向けに幅を調整 */
    right: 5vw; /* 画面中央に近づける */
    padding: 5px; /* スマートフォン向けにパディングを調整 */
  }

  @media screen and (min-width: 769px) and (max-width: 1124px) {
    top: 44vh; /* タブレット向けに中央に配置 */
    margin: 0 auto; /* 中央に配置 */
    height: 45vh; /* タブレット向けに高さを調整 */
    /**中央に配置 */
    width: 90vw; /* タブレット向けに幅を調整 */
    right: 0;
    left: 0;
  }
`;

interface ContentAreaProps {
  itemData: MenuItem; // 表示するコンテンツの元となるメニューアイテムデータ
  onClose: () => void; // 閉じるボタンのコールバック
}

const ContentArea: React.FC<ContentAreaProps> = ({ itemData, onClose }) => {
  const location = useLocation();
  return (
    <ContentContainer>
    <motion.div
      initial={{ opacity: 0, x: 100 }} // 初期状態 (画面外右、透明)
      animate={{ opacity: 1, x: 0 }}   // 表示状態 (画面内、不透明)
      exit={{ opacity: 0, x: 100 }}     // 非表示状態 (画面外右、透明)
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
    >
      
      <div style={{ position: 'relative', textAlign: 'center' }}>
        <h2 style={{ marginTop: 0, color: 'cyan' }}>{itemData.name}</h2>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0px',
            right: '20px',
            padding: '12px 20px',
            backgroundColor: 'rgba(0, 200, 200, 0.8)',
            color: '#111',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '16px',
            transition: 'background-color 0.2s',
            zIndex: 20, // ボタンを他のコンテンツの上に表示
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'cyan')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(0, 200, 200, 0.8)')}
        >
          閉じる
        </button>
      </div>
      {
        // ここでitemDataに基づいてコンテンツを表示
        // 例えば、itemData.pathに応じて異なるコンポーネントを表示するなど
        location.pathname === '/home' ? (
          <Home />
        ) : location.pathname === '/philosophy' ? (
          <Philosophy />
        ) : location.pathname === '/profile' ? (
          <Profile />
        ) : location.pathname === '/works' ? (
          <Works />
        ) : location.pathname === '/recruitment' ? (
          <Recruitment />
        ) : location.pathname === '/contact' ? (
          <ContactPage />
        ) : (
          <div>
            <p>選択されたコンテンツ: {itemData.name}</p>
            <p>ここに他のコンテンツを追加できます。</p>
          </div>
        )
      }
      
    </motion.div>
    </ContentContainer>
  );
};

export default ContentArea;